import { state } from '@angular/animations';
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { Post } from 'src/models/blog';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
  listPosts: any[] = [];
  allPosts: any[] = [];
  categorias: any[] = [];
  tags: any[] = [];
  quantity: number = 6;

  filtroTag: any = null;
  filtroCategoria: any = null;
  posts: Post[] = [];
  postsVejaTmb: Post[] = [];
  postsHighlights: Post[] = [];
  postCategoria = '';
  categoriaId: string = '';
  pageIndex = 0;

  perPage = 5;
  isSubmitted = false;
  finalColumns = 0;
  cardsPerRow = 0;
  cdr: any;
  inscricao: any;
  id!: number;
  index: number = 0

  quantityPostWithOutCategory = 0


  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private elementRef: ElementRef,


  ) {
    this.verificarTipoCategoria();
  }

  ngOnInit(): void {
    this.inscricao = this.route.params.subscribe(
      (params: any) => {

        if (params['categoriaId'] != undefined) {
          this.filtroCategoria = +params['categoriaId'];
        }
        if (params['tagId'] != undefined) {
          this.filtroTag = +params['tagId'];
        }
        if (params['id'] != undefined) {
          this.id = +params['id'];
        }
      }
    )

    this.loadBlogCategoria();
    this.loadBlogTags();
    this.loadAllPost();
    if (this.filtroCategoria || this.filtroCategoria === 0) {
      this.loadPostsByCategory(this.filtroCategoria)
    }
    if (this.filtroTag) {
      this.loadPostsByTag(this.filtroTag)
    }

  }

  verificarTipoCategoria() {
    this.categorias.forEach(categoria => {
      categoria.isNumero = !isNaN(categoria.id);
    });
  }

  loadAllPost() {
    this.apiService.loadPosts().subscribe((data) => {
      if (data) {
        this.paginatePosts(data)
        this.verifyPostsWithoutCategory()
      }

    })
  }

  loadMorePosts(quantity: number) {
    const sliceStart = this.listPosts.length;
    let sliceEnd: number;
    if (sliceStart + quantity <= this.allPosts.length) {
      sliceEnd = sliceStart + quantity;
    } else {
      sliceEnd = this.allPosts.length;
    }
    this.listPosts = [...this.listPosts, ...this.allPosts.slice(sliceStart, sliceEnd)];
  }

  loadPostsByCategory(id: number | undefined) {
    this.apiService.loadPosts().subscribe(data => {
      let postsTmp : any = []
      if(id){
        postsTmp = data.filter(post => {
        return post.categorias.length > 0 && typeof post.categorias[0].id === 'number' && post.categorias[0].id === id;
      });
      } else {
        postsTmp = data.filter(post => post.categories.length == 0)
      }

      if (postsTmp.length > 0) {
        this.paginatePosts(postsTmp);
      }
    });

  }
  loadPostsByTag(id: number) {
      this.apiService.loadPosts().subscribe(data => {

      let postsTmpTag = data.filter(data => data.tags.some(tag => +tag === id));

      if (postsTmpTag.length > 0) {
        this.paginatePosts(postsTmpTag);
      }
    })
  }

  paginatePosts(postsData: Post[]) {
    this.allPosts = postsData;
    if (this.allPosts && this.allPosts.length <= 6) {
      this.listPosts = this.allPosts;
    } else if (this.allPosts && this.allPosts.length > 6) {
      this.listPosts = this.allPosts.slice(0, 6);
    }
  }

  verifyPostsWithoutCategory() {
    this.allPosts.map(p => {
          if (p.categories.length == 0) { this.quantityPostWithOutCategory++ }
    })
  }

  loadBlogCategoria() {
    this.apiService.getPostsCategories().subscribe(itens => {
      this.categorias = itens
       });
  }
  loadBlogTags() {
    this.apiService.getTags().subscribe(itens => {
      this.tags = [];
      for (let i = 0; i < itens.length; i++) {
        if (itens[i].count >= 1) {
          this.tags.push(itens[i]);
        }
      }
    });
  }
  openCategoriaId(categoria: any = undefined) {
    if(categoria){
      this.filtroCategoria = categoria.id
    } else
    this.filtroCategoria = 0
    this.loadPostsByCategory(this.filtroCategoria)
    this.router.navigate([`/blog/categoria/${this.filtroCategoria}`])
  }

  openTag(tag: any) {
    this.router.navigate([`/blog/tags/${tag.id}`])
    this.filtroTag = tag.id
    this.loadPostsByTag(this.filtroTag)
  }
  scrollToTop() {
    this.elementRef.nativeElement.ownerDocument.documentElement.scrollTop = 0;
  }

  openPost(post: Post) {
    this.router.navigate([`/blog/detalhes/${post.id}`],
      {
        state: { post: post }
      });
  }

}
